import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function controlsDetailsReducer(state = initialstate.controlsDetails, action) {
	switch (action.type) {
		case types.GET_CONTROL_BY_ID:
			return action.response || state;
		case types.GET_ALL_CONTROLS:
			return action.response || state;
		default:
			return state;
	}
}
